<main class="person-events-content"><router-outlet></router-outlet></main>
